import { ActionType } from '../types';
import { Types } from './actions';
import { NO_SAML_REDIRECT } from './constants';
import { mergeReducers, isPayloadEmpty } from '~/store/utils';
import { isEmpty } from '~/utils/object';

const initialState = {
  loading: undefined,
  success: undefined,
  error: undefined,
  samlRedirectUrl: NO_SAML_REDIRECT,
  username: undefined,
};

const usernameReducer = (state = initialState, action: ActionType) => {
  const { type } = action;
  switch (type) {
    case Types.USERNAME_LOGIN_REQUEST: {
      return {
        success: undefined,
        error: action.payload.runningOnBackground ? state.error : undefined,
        loading: !action.payload.runningOnBackground,
        samlRedirectUrl: NO_SAML_REDIRECT,
        username: action.payload.username,
      };
    }
    case Types.USERNAME_LOGIN_SUCCESS: {
      return {
        ...state,
        success: true,
        loading: false,
        error: undefined,
        samlRedirectUrl: action.payload,
      };
    }
    case Types.USERNAME_LOGIN_FAILURE: {
      return {
        ...state,
        error: isEmpty(action.payload) ? undefined : action.payload,
        success: false,
        loading: false,
        samlRedirectUrl: NO_SAML_REDIRECT,
      };
    }
    case Types.USERNAME_LOGIN_ERROR: {
      return {
        ...state,
        error: action.payload,
        success: false,
        loading: false,
        samlRedirectUrl: NO_SAML_REDIRECT,
      };
    }
    case Types.SET_USERNAME: {
      return {
        ...state,
        username: isPayloadEmpty(action.payload) ? '' : action.payload,
      };
    }
    default:
      return state;
  }
};
const passwordReducer = (state = initialState, action: ActionType) => {
  const { type } = action;
  switch (type) {
    case Types.PASSWORD_LOGIN_REQUEST: {
      return {
        success: undefined,
        error: undefined,
        loading: true,
        samlRedirectUrl: NO_SAML_REDIRECT,
        username: action.payload.username,
      };
    }
    case Types.PASSWORD_LOGIN_SUCCESS: {
      return {
        ...state,
        success: true,
        loading: false,
        error: undefined,
      };
    }
    case Types.PASSWORD_LOGIN_FAILURE: {
      return {
        ...state,
        error: action.payload,
        success: false,
        loading: false,
        samlRedirectUrl: NO_SAML_REDIRECT,
      };
    }
    case Types.PASSWORD_LOGIN_ERROR: {
      return {
        ...state,
        error: action.payload,
        success: false,
        loading: false,
        samlRedirectUrl: NO_SAML_REDIRECT,
      };
    }
    case Types.PASSWORD_LOGIN_RESET: {
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
};

const commonReducer = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case Types.CLEAR_LOGIN: {
      return initialState;
    }
    default:
      return state;
  }
};

export default mergeReducers([usernameReducer, passwordReducer, commonReducer]);
